import type { BigIntLike } from '../types';

/**
 * Billing endpoints serialize BigInt counters as strings. Coerce to a
 * plain number for meters and math; unparseable/missing input → 0.
 */
export function toNumber(value: BigIntLike | null | undefined): number {
    if (value == null) return 0;
    const n = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(n) ? n : 0;
}

/** Like `toNumber`, but preserves "no value" (e.g. an unlimited resource). */
export function toNullableNumber(value: BigIntLike | null | undefined): number | null {
    if (value == null) return null;
    const n = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(n) ? n : null;
}

/** Grouped-digit rendering for unit counts: 1234567 → "1,234,567". */
export function formatUnits(value: BigIntLike | null | undefined): string {
    return toNumber(value).toLocaleString('en-US');
}
